'use strict';

const React = require('react'),
  {t} = require('services/i18nextWrapper'),
  NavigationUtils = require('utils/NavigationUtils');

const PreActivated = React.createClass({displayName: "PreActivated",
  
  render: function () {
    return (
      React.createElement("div", {className: "preactivated-page-container jumbotron"}, 
        React.createElement("div", {className: "container text-center"}, 
          React.createElement("h1", {className: "preactivated-page-container__header light"}, t('pre_activated_title')), 
          React.createElement("p", {
            className: "preactivated-page-container__body"}, `${t('pre_activated_description_1')} `, React.createElement("strong", null, NavigationUtils.getQueryParam('email')), ` ${t('pre_activated_description_2')}`
          ), 
          React.createElement("br", null), 
          React.createElement("div", {className: "preactivated-page-container__footer"}, 
            React.createElement("p", {
              className: "preactivated-page-container__footer-signature"}, t('confirm_new_password_static_page_greeting')), 
            React.createElement("img", {style: {height: '60px'}, src: "/assets/images/logo-small-dark.png"}), 
            React.createElement("p", {className: "preactivated-page-container__mail-support"}, 
              `${t('pre_activated_did_not_receive_email')} `, React.createElement("a", {
              href: "mailto:support@brewplanner.com?Subject=Need%20help", 
              target: "_top"}, "support@brewplanner.com"), "."
            )
          )
        )
      )
    );
  }
});

module.exports = PreActivated;




/** WEBPACK FOOTER **
 ** ./src/views/PreActivated/PreActivated.jsx
 **/